export const Functions = {
  create: true,
  delete: false,
  detail: false,
  search: true,
};

export const PageName = '充值管理';
